import type { IxcDtccCnsV1AssetDayKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const CNS_ASSET_DAY_BASE_PATH = '/clearing/operations/dtcc/asset-day';

export const getCnsAssetDayPath: EntityPathBuilder<IxcDtccCnsV1AssetDayKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CNS_ASSET_DAY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId && !context?.keys?.date) {
        return undefined;
      }

      return getResolvedPath(`${CNS_ASSET_DAY_BASE_PATH}/$assetId/$date`, context?.keys);
    }
  }
};

export function getCnsAssetDayDetailPath(assetId: string | undefined, date: string | undefined) {
  if (!assetId || !date) {
    return undefined;
  }

  return getCnsAssetDayPath({ kind: 'detail', keys: { assetId, date } });
}
